import { render, staticRenderFns } from "./ForYou.vue?vue&type=template&id=10c85cd6&scoped=true"
import script from "./ForYou.vue?vue&type=script&lang=js"
export * from "./ForYou.vue?vue&type=script&lang=js"
import style0 from "./ForYou.vue?vue&type=style&index=0&id=10c85cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c85cd6",
  null
  
)

export default component.exports